import { AdministerMerchant, kybMerchant } from 'APIs/merchants/merchants';
import React, { MouseEvent, ReactElement, useCallback, useState } from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import getErrorMessage from 'utils/getErrorMessage';

import { useCreateMerchantContext } from '../../../context';
import OnboardingStatusView from './OnboardingStatusView';

const OnboardingStatus = (): ReactElement => {
  const { merchantId, merchant, setMerchant, merchantStatus, fetchMerchant } = useCreateMerchantContext();

  const { apiBaseUri, apiAprilBaseUri } = useSelector((state: ReduxStateType) => ({
    apiBaseUri: state.apiBaseUri,
    apiAprilBaseUri: state.apiAprilBaseUri,
  }));

  const [isVerifyButtonLoading, setIsVerifyButtonLoading] = useState<boolean>(false);
  const [isManKYBButtonLoading, setIsManKYBButtonLoading] = useState<boolean>(false);

  const handleVerify = useCallback(
    async (e: MouseEvent<HTMLButtonElement>) => {
      e.preventDefault();
      try {
        setIsVerifyButtonLoading(true);
        const payload = { ActivateMerchant: {} };
        const resp = await AdministerMerchant(apiAprilBaseUri, merchantId, payload);
        setMerchant(resp);
      } catch (error) {
        toast.error(getErrorMessage(error));
      } finally {
        setIsVerifyButtonLoading(false);
      }
    },
    [apiAprilBaseUri, merchantId, setMerchant],
  );

  const handleManualKYB = useCallback(
    async (e: MouseEvent<HTMLButtonElement>) => {
      e.preventDefault();
      const confirmed = window.confirm(
        'Are you sure you want to mark KYB as completed and send onboarding complete email?',
      );

      if (!confirmed) return;

      try {
        setIsManKYBButtonLoading(true);
        const resp = await kybMerchant(apiBaseUri, merchantId);
        if (resp.status === 'Verified') {
          toast.success('KYB successful. Onboarding complete email sent.');
          await fetchMerchant();
        } else {
          toast.error('KYB failed');
        }
      } catch (error) {
        toast.error(getErrorMessage(error));
      } finally {
        setIsManKYBButtonLoading(false);
      }
    },
    [apiBaseUri, fetchMerchant, merchantId],
  );

  return (
    <OnboardingStatusView
      merchantId={merchantId}
      merchant={merchant}
      merchantStatus={merchantStatus}
      isVerifyButtonLoading={isVerifyButtonLoading}
      isManKYBButtonLoading={isManKYBButtonLoading}
      handleVerify={handleVerify}
      handleManualKYB={handleManualKYB}
    />
  );
};

export default OnboardingStatus;
